module.exports = __webpack_public_path__ + "img/icon90.0573f5a6.png";